import { Browser } from '@capacitor/browser';

/* istanbul ignore next -- @preserve */
export const openLinkInCortexApp = async (url: string): Promise<void> => {
  await Browser.open({ url });
};
